import React from "react";
import DealListQuery, { getDealList } from "@irati/deals/apollo/query/DealList";
import { FormattedMessage } from "@irati/utils/lang";
import { getThumbnailImage } from "@irati/utils/images/getImageSize/getImageSize";
import Tag from "@irati/ui/src/Tag";
import HR from "@irati/ui/src/Layout/Hr";
import { H5 } from "@irati/ui/src/Headings";
import Close from "@irati/ui/src/Close";
import Flex from "@irati/ui/src/Flex";
import { DealStatus } from "@irati/types";
import DescriptionModal from "../styled/DescriptionModal";
import ThumbnailImage from "../styled/ThumbnailImage";
import { TagModalList, CenteredTag } from "./styled";
var TagModal = function (_a) {
    var tag = _a.tag, onHide = _a.onHide;
    return (React.createElement(DescriptionModal, { backdrop: true, backdropClassName: "consistentBackdrop", dialogClassName: "tagPopUp", show: !!tag, onHide: onHide },
        React.createElement(CenteredTag, null,
            React.createElement(Tag, { name: tag.name, selected: false, onClick: function () { } })),
        React.createElement(Close, { top: "20px", right: "20px", onClick: onHide }),
        React.createElement(H5, { className: "text-center push--bottom" },
            React.createElement(FormattedMessage, { id: "admin.components.tagModal.headerFive.tagName", values: { tagname: tag.name } })),
        React.createElement(TagModalList, null,
            React.createElement(DealListQuery, { variables: {
                    tags: [tag.uuid],
                    statuses: [DealStatus.On],
                    ignoreBlacklist: false
                } }, function (apollo) {
                var dealsList = getDealList(apollo);
                return (React.createElement(React.Fragment, null, dealsList.results.map(function (deal) { return (React.createElement("div", { key: deal.uuid },
                    React.createElement(Flex, { alignItems: "center", justifyContent: "flex-start" },
                        React.createElement(ThumbnailImage, { src: getThumbnailImage(deal.thumbnailImage) }),
                        React.createElement(H5, null, deal.header)),
                    dealsList.results.length > 1 && React.createElement(HR, null))); })));
            }))));
};
export default TagModal;
